import React, { useState } from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './RoleDropdown.module.scss';

const RoleDropdown = ({ roles, onRoleSelect }) => {
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const { t } = useTranslation();

  const lastItem = { name: t('composite.rolesScreen.copyServicesModal.enterPricesManualText'), id: 0 };
  const addedRoles = [...roles, lastItem];

  const handleRoleClick = (roleId) => {
    const newSelectedRoleId = selectedRoleId === roleId ? null : roleId;
    setSelectedRoleId(newSelectedRoleId);
    onRoleSelect(newSelectedRoleId); // Pass the updated roleId (or null) to the parent
  };

  return (
    <div data-bem="RoleDropdown" className={CN.component}>
      {addedRoles.map((role) => (
        <div
          data-bem="RoleDropdown__item"
          key={role.id}
          role="button"
          tabIndex={0}
          onClick={() => handleRoleClick(role.id)}
          className={cn({
            [CN.item]: true,
            [CN.selected]: selectedRoleId === role.id,
          })}
        >
          <Icon variant="radioCheck" selected={selectedRoleId === role.id} width="lg" />
          <div className={CN.itemName}>{role.name}</div>
        </div>
      ))}
    </div>
  );
};

export default RoleDropdown;
